"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allegroSymbolRefForCell = allegroSymbolRefForCell;
function allegroSymbolRefForCell(cellName, view, sectionNumber = 1) {
    return `${cellName}__${view}__sec${sectionNumber}__sym`;
}
//# sourceMappingURL=AllegroResolved.js.map